var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpgradeArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 111 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.78 54.753C71.305 39.306 67.37 20.52 65.26 3.906 64.884.902 61.367-.1 59.674 2.332c-9.3 13.421-21.151 27.748-32.87 38.356-2.33 2.122-.726 6.222 2.308 5.912l14.885-1.502c-4.375 20.12-9.498 40.072-15.874 59.596-3.65 11.204-7.717 22.289-12.313 33.111-4.573 10.823-9.74 21.383-15.654 31.491-.264.476-.198 1.096.22 1.454a.962.962 0 0 0 1.429-.167c7.014-9.416 13.368-19.428 19.172-29.798 5.827-10.37 11.125-21.097 16.05-32.039 8.663-19.213 16.095-39.047 22.779-59.19l12.312 9.154c2.507 1.86 5.76-.882 4.661-3.957Z",
    fill: "url(#upgrade-arrows-first)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.777 105.212c-5.545-15.448-9.532-34.232-11.67-50.847-.379-3.004-3.942-4.005-5.657-1.574-9.422 13.421-21.426 27.748-33.297 38.356-2.361 2.122-.735 6.222 2.338 5.912l15.079-1.502c-4.433 20.12-9.622 40.072-16.08 59.596-3.698 11.204-7.818 22.289-12.473 33.111-4.633 10.823-9.867 21.383-15.858 31.491-.267.476-.2 1.096.223 1.454a.982.982 0 0 0 1.447-.167c7.105-9.416 13.542-19.428 19.422-29.798 5.902-10.37 11.27-21.097 16.258-32.039 8.775-19.213 16.303-39.047 23.074-59.19l12.473 9.154c2.539 1.859 5.835-.882 4.721-3.957Z",
    fill: "url(#upgrade-arrows-second)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "upgrade-arrows-first",
    x1: 67.507,
    y1: 0.969,
    x2: -31.651,
    y2: 67.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upgrade-arrows-second",
    x1: 102.5,
    y1: 51.428,
    x2: 12.281,
    y2: 113.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A6A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeArrows);
export default __webpack_public_path__ + "static/media/upgrade-arrows.791246242699212548957ca583c08626.svg";
export { ForwardRef as ReactComponent };